(function () {
  const KEY = "prestige_wishlist";

  const get = () => {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; }
    catch (e) { return []; }
  };

  const set = (items) => localStorage.setItem(KEY, JSON.stringify(items));

  const updateCount = () => {
    const count = get().length;
    document.querySelectorAll(".wishlist-count").forEach(el => {
      el.textContent = count;
    });
  };

  const syncButtons = () => {
    const items = get();
    document.querySelectorAll(".wishlist-btn").forEach(btn => {
      const id = btn.dataset.productId;
      const exists = items.some(p => p.id === id);
     
      btn.innerHTML = exists
  ? '<i class="fa-solid fa-heart"></i> '
  : '<i class="fa-regular fa-heart"></i> ';

    });
  };

  // Event delegation (works with AJAX navigation too)
  document.addEventListener("click", (e) => {
    const btn = e.target.closest(".wishlist-btn");
    if (!btn) return;

    const item = {
      id: String(btn.dataset.productId || ""),
      title: btn.dataset.productTitle || "",
      url: btn.dataset.productUrl || "",
      image: btn.dataset.productImage || ""
    };

    if (!item.id) return;

    let items = get();
    const exists = items.some(p => p.id === item.id);

    items = exists ? items.filter(p => p.id !== item.id) : [...items, item];

    set(items);

    updateCount();
    syncButtons();

    document.dispatchEvent(new CustomEvent("wishlist:updated"));
  });

  // Run on initial load
  const init = () => {
    updateCount();
    syncButtons();
  };

  // First load
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  // Prestige often re-renders sections, so re-sync after navigation/section load
  document.addEventListener("shopify:section:load", init);
  document.addEventListener("shopify:section:reorder", init);
})();
